import React, { useState } from "react";

function FAQ() {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqData = [
    {
      question: " What are AI automation services?",
      answer: "ai automation services use artificial intelligence to automate repetitive tasks, improve efficiency, and streamline business operations without manual effort.",
    },
    {
      question: "How does AI powered automation help businesses?",
      answer: "ai powered automation helps businesses save time, reduce errors, and improve productivity by automating workflows, data processing, and decision-making tasks.",
    },
    {
      question: "What are AI chatbots used for in customer service?",
      answer: "ai chatbots for customer service are used to handle customer queries, provide instant responses, and offer 24/7 support, improving customer satisfaction and engagement.",
    },
    {
      question: " How does AI improve software testing?",
      answer: "With ai for software testing, businesses can automate test cases, detect bugs faster, and improve software quality while reducing testing time and effort.",
    },
    {
      question: "What is automatic machine learning?",
      answer: "automatic machine learning (AutoML) allows businesses to build and deploy machine learning models automatically, making data analysis and predictions easier without deep technical knowledge.",
    },

  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="k-faq-section">
      <div className="k-faq-container">
        <h2 className="k-faq-heading">Frequently Asked Questions</h2>

        {faqData.map((item, index) => (
          <div
            key={index}
            className={
              activeIndex === index ? "k-faq-box active" : "k-faq-box"
            }
          >
            <div
              className="k-faq-question"
              onClick={() => toggleFAQ(index)}
            >
              <span className="k-faq-title">{item.question}</span>
              <span className="k-faq-arrow">
                {activeIndex === index ? "▲" : "▼"}
              </span>
            </div>

            <div className="k-faq-answer">
              <p className="k-faq-text">{item.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default FAQ;